import { Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(6),
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: 1.4,
}));

export const StepText = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));
